import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useParams, useNavigate } from 'react-router-dom'
import { getTrack } from '@disco/state-management/selectors/tracks'
import DocumentHeadTags from 'components/document-head-tags'
import ManageTrackFormatsModal from 'components/modals/track/manage-track-formats'
import type { State } from 'types/redux'
import type { RootState } from 'store/configureStore'
interface OwnProps {
  params: {
    trackId: string
  }
  navigate: NavigateFunction
}

function mapStateToProps(state: RootState, props: OwnProps) {
  return {
    track: getTrack(state, {
      id: parseInt(props.params.trackId, 10),
    }),
  }
}

const mapDispatchToProps = {}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>
type ManageTrackFormatsProps = PropsFromRedux & OwnProps

class ManageTrackFormats extends Component<ManageTrackFormatsProps> {
  _onClose = () => this.props.navigate('/')
  _addFormat = () =>
    this.props.navigate(`/explorer/tracks/${this.props.track.id}/add-format`)
  _replaceFormat = format =>
    this.props.navigate(
      `/explorer/tracks/${this.props.track.id}/replace-format/${format}`,
    )
  _deleteFormat = format =>
    this.props.navigate(
      `/explorer/tracks/${this.props.track.id}/delete-format/${format}`,
    )

  render() {
    return (
      <div>
        <DocumentHeadTags
          title={`Manage formats for ${this.props.track.name} | DISCO`}
        />
        <ManageTrackFormatsModal
          track={this.props.track}
          onClose={this._onClose}
          onAddFormat={this._addFormat}
          onReplaceFormat={this._replaceFormat}
          onDeleteFormat={this._deleteFormat}
        />
      </div>
    )
  }
}

const ConnectedManageTrackFormats = connector(ManageTrackFormats)

// Wrapper component to provide router params and navigation to the connected component
const ManageTrackFormatsWithRouter = (props: any) => {
  const params = useParams<{ trackId: string }>()
  const navigate = useNavigate()

  return (
    <ConnectedManageTrackFormats
      {...props}
      params={params}
      navigate={navigate}
    />
  )
}

export default ManageTrackFormatsWithRouter
